import * as React from "react"
import styled from "styled-components"
import { MediaQuery } from "../../utils/design-helpers"

const CardBar = styled.div<{ open: boolean }>`
  padding: ${(props) => `${props.theme.spacings.large} ${props.theme.spacings.extreme}`};
  background-color: ${(props) => props.theme.colors.dark};
  box-shadow: 0px 0px 4px rgba(119, 119, 119, 0.25);
  border-radius: ${(props) => (props.open ? "24px 24px 0 0" : props.theme.borders.largeRadius)};
  width: 100%;

  ${MediaQuery.XS} {
    padding: 1rem;
  }
`

export default CardBar
